export const ALERTS_GRID_AREA = 'alerts';
export const SENDS_GRID_AREA = 'sends';
